module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-8"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content padding-top"
  }, [(_vm.hasInsurances()) ? _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.hasInsurances()) ? _c('table', {
    staticClass: "table table-hover table-filter-default"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.passengers), function(passenger) {
    return _c('tbody', _vm._l((passenger.insurances), function(insurance) {
      return _c('tr', [_c('td', [_vm._v("\r\n                  " + _vm._s(_vm.formatName(passenger.passenger)) + "\r\n                ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                  " + _vm._s(insurance.name) + "\r\n                ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                  " + _vm._s(_vm.getRateIcon(insurance.rate_type)) + _vm._s(insurance.rate) + "\r\n                ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                  " + _vm._s(insurance.rate_type) + "\r\n                ")])])
    }), 0)
  })], 2) : _vm._e()]) : _c('div', [_c('p', [_vm._v("Er zijn geen verzekeringen afgesloten.")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("\r\n          Verzekeringen\r\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Passagier")]), _vm._v(" "), _c('th', [_vm._v("Verzekering")]), _vm._v(" "), _c('th', [_vm._v("Prijs")]), _vm._v(" "), _c('th', [_vm._v("Prijs type")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35198636"}!./src/templates/reservations/insurances.html
// module id = 534
// module chunks = 1